<template>
  <loginless-layout :title="$t('titles.companySetup')">
    <loadable :loading="isBusy" only-hide>
      <form @submit.prevent="save">
        <v-alert
          info
          :value="true"
          class="mb-3"
        >
          {{ $t('companySetup.description') }}
        </v-alert>

        <public-key-input
          v-model="publicKey"
          :label="$t('companySetup.publicKey')"
          required
          class="mb-4"
        />

        <v-card-actions>
          <v-btn type="submit">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </form>
    </loadable>
  </loginless-layout>
</template>

<script>
import LoginlessLayout from '@/components/LoginlessLayout'
import PublicKeyInput from '@/components/PublicKeyInput'
import Company from '@/models/Company'

export default {
  data () {
    return {
      isBusy: false,
      publicKey: null
    }
  },
  created () {
    // Only allow access when needed
    if (!this.$auth.requiresKey()) {
      this.$router.push('/')
    }
  },
  methods: {
    save () {
      let company = this.$store.auth.user.company
      let configuration = company.configuration
      if (!configuration) {
        configuration = {
          _self: null,
          maxAge: null,
          encrypt: 'KEY',
          compression: 'PCM',
          encryptionKey: null,
          insertIdent: false,
          certificates: []
        }
      }

      configuration.encrypt = 'KEY'
      configuration.encryptionKey = this.publicKey

      this.isBusy = true

      Company
        .saveConfiguration(company, configuration)
        .then(result => {
          result.encryptionKeyExists = !!result.encryptionKey
          company.configuration = result
          this.$router.push('/')
        })
        .catch(err => {
          this.isBusy = false
          alert(this.$t('savingFailed') + err)
        })
    }
  },
  components: {
    LoginlessLayout,
    PublicKeyInput
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// CompanySetup.vue?962014d2